import React, {useState} from "react";
import { Link } from 'react-router-dom';
import Toast from 'react-bootstrap/Toast';
import {ToastContainer} from "react-bootstrap";

const Navbar = () => {
    const [show, setShow] = useState(true);
    const dismissToast = () => {
        setShow(false);
    };
    return (
        <>
        <nav className="navbar navbar-expand navbar sticky-top">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse container-fluid d-flex justify-content-center">
                <div className="navbar-nav">
                    <Link className="nav-link" to="/Home" aria-current="page">Home</Link>
                    <Link className="nav-link" to="/Todo">Todo</Link>
                    <Link className="nav-link" to="/Calendar">Calendar</Link>
                    <Link className="nav-link" to="/Options">Options</Link>
                </div>
            </div>

        </nav>
        <ToastContainer className="supportToast" position="bottom-end">
            <Toast bg="dark" variant="dark" onClose={dismissToast} show={show}>
                <Toast.Header>
                    <strong className="me-auto">Contact Me</strong>
                </Toast.Header>
                <Toast.Body className="text-white">Need support or fancy a chat? Feel free to email
                    <a href="mailto:enquiries@academicaccord.com"> enquiries@academicaccord.com</a>
                </Toast.Body>
            </Toast>
        </ToastContainer>
        </>
    );
};
export default Navbar;

